import { Route, Routes } from "react-router-dom";

import Login from "./pages/Login";

import Main from "./pages/Main";
import Register from "./pages/Register";

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/form" element={<Main />} />
      </Routes>
    </>
  );
}

export default App;
